const ErrorIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M9.13398 3.5C9.51888 2.83333 10.4811 2.83333 10.866 3.5L16.9282 14C17.3131 14.6667 16.832 15.5 16.0622 15.5H3.93782C3.16802 15.5 2.6869 14.6667 3.0718 14L9.13398 3.5Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99195 13C9.99195 13 9.99419 13 9.99695 13C9.99971 13 10.002 13 10.002 13"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 7V11"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export { ErrorIcon };
